// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapIcon } from '../../../dsl/front';
let ReadingTime = class ReadingTime extends Vue {
};
__decorate([
    Prop({ type: Number, required: true })
], ReadingTime.prototype, "time", void 0);
ReadingTime = __decorate([
    Component({
        name: 'ReadingTime',
        components: { BootstrapIcon },
        template: `
    <div class="reading-time">
      <BootstrapIcon name="clock" />
      {{time}} min.
    </div>
  `
    })
], ReadingTime);
export { ReadingTime };
